<template>
    <div @click.self="closeModal" class="fixed inset-0 z-50 overflow-auto bg-gray-900 bg-opacity-50 flex justify-center items-center">
        <div @click.stop class="h-fit w-2/5 bg-white flex flex-col items-center justify-between p-3">
            <div class="flex flex-col py-2 h-full w-full gap-2">
                <div>
                    <p class="text-lg font-bold text-gray-700 mb-1 text-center">Edit Attribute</p>
                </div>
                <hr/>

                <form class="max-w-sm mx-auto" @submit.prevent="updateAttribute">
                    <div class="mb-5">
                        <label for="inc" class="block mb-2 text-sm font-medium text-gray-900">Inc</label>
                        <select name="" id="" class="bg-gray-100 w-64" v-model="attributeData.inc">
                            <option value="" selected disabled>Pilih INC Code</option>
                            <option v-for="item in incData" :key="item.id" :value="item.INC">{{ item.INC }} - {{item.INCName}}</option>
                        </select>
                    </div>
                    <div>
                        <div class="mb-5">
                            <label for="attr_code" class="block mb-2 text-sm font-medium text-gray-900">Attribute Code</label>
                            <input type="text" id="attr_code" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="Attribute Code" v-model="attributeData.attributeCode" required>
                        </div>
                        <div class="mb-5">
                            <label for="attr_name" class="block mb-2 text-sm font-medium text-gray-900">Attribute Name</label>
                            <input type="text" id="attr_name" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="Attribute Name" v-model="attributeData.attributeName" required>
                        </div>
                        <div class="mb-5">
                            <label for="sequence" class="block mb-2 text-sm font-medium text-gray-900">Sequence</label>
                            <input type="number" id="sequence" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="Sequence" v-model="attributeData.sequence" required>
                        </div>
                    </div>
            
                    <button type="submit" class="text-white focus:ring-4 focus:outline-none font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center bg-blue-600 hover:bg-blue-700 focus:ring-blue-800">Submit</button>
                </form>
            </div>
        </div>        
    </div>
</template>
<script>
export default {
    props: {
        attribute: Object
    },
    data() {
        return {
            attributeData: {},
            selectedInc: null,
            attributeCode: '',
            attributeName: '',
            sequence: '',
        };
    },
    methods: {
        closeModal(event) {
            if (event.target.classList.contains('bg-gray-900')) {
                this.$emit('close');
            }
        },
        updateAttribute() {
            try{
                const attribute = {
                    id: this.attributeData.id,
                    inc: this.attributeData.inc,
                    attributeCode: this.attributeData.attributeCode,
                    attributeName: this.attributeData.attributeName,
                    sequence: this.attributeData.sequence,
                }
                // const listId = this.selectedRow.map(objek => objek.id);
                this.$store.dispatch('updateAttribute', { attribute });
                this.$toast.success('Attribute Baru Berhasil Tersimpan', {
                    duration: 2500,
                    position: 'top-right'
                });
            }
            catch(error){
                this.$toast.error(`Gagal Menyimpan Attribute Baru, ${error}`, {
                    duration: 2500,
                    position: 'top-right'
                });
            }
        }
    },
    computed: {
        incData() {
            return this.$store.getters.getIncData
        },
    },
    mounted() {
         this.attributeData = { ...this.attribute };
         console.log('data: --',this.attributeData);
    }
}
</script>